module.exports = "<app-intro></app-intro>\n<app-pizzas></app-pizzas>\n<app-map id=\"infos\"></app-map>\n"